import { render, staticRenderFns } from "./additionalservice.vue?vue&type=template&id=fd745ffe&scoped=true&"
import script from "./additionalservice.vue?vue&type=script&lang=js&"
export * from "./additionalservice.vue?vue&type=script&lang=js&"
import style0 from "./additionalservice.vue?vue&type=style&index=0&id=fd745ffe&prod&lang=scss&scoped=true&"
import style1 from "./additionalservice.vue?vue&type=style&index=1&id=fd745ffe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd745ffe",
  null
  
)

export default component.exports